import React from 'react'

const NoMenuRoute = (props) => {
  return ( <></> );
}

export default NoMenuRoute;